export default "/institutions/wise.svg";